import { render } from "./SlideMenuEditComponent.vue?vue&type=template&id=96d340c6&scoped=true"
import script from "./SlideMenuEditComponent.vue?vue&type=script&lang=js"
export * from "./SlideMenuEditComponent.vue?vue&type=script&lang=js"

import "./SlideMenuEditComponent.vue?vue&type=style&index=0&id=96d340c6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96d340c6"]])

export default __exports__